import { Component, Input, OnInit } from '@angular/core';
import { FirebaseService } from "../../providers/firebase.service";
import { ClientSettings } from "../../models/client-settings";
import { Client } from "../../models/client";

@Component({
  selector: 'component-structure',
  templateUrl: './component-structure.component.html',
  styleUrls: ['./component-structure.component.scss']
})
export class ComponentStructureComponent implements OnInit {
  @Input() name: string;
  @Input() model;
  @Input() options: any;
  @Input() clientData: Client;
  @Input() dataName = '';

  clientSettings = new ClientSettings();

  settings: any;
  constructor(
    public afService: FirebaseService
  ) { }

  ngOnInit() {
    this.setSettings();
  }

  setSettings() {
    if (this.dataName)
      this.settings = this.clientSettings[this.dataName][this.clientData[this.model]];
  }

  updateClient() {
    //   if (this.dataName)
    this.settings = this.clientSettings[this.dataName][this.clientData[this.model]];

    this.afService.updateClient(this.clientData).then((data) => {
      this.afService.openSnackBar('Data successfully saved.');
    });
  }

  updateClientSlideToggle(e, name) {
    this.clientData[this.dataName][name] = e.checked;

    // if (this.dataName)
    this.settings = this.clientSettings[this.dataName][this.clientData[this.model]];

    this.afService.updateClientDataModel(this.clientData, this.dataName, this.clientData[this.dataName]).then((data) => {
      this.afService.openSnackBar('Data successfully saved.');
    });
  }

  updateColor(itemName, color) {
    this.clientData[this.dataName][itemName] = color;
    this.afService.updateClientDataModel(this.clientData, this.dataName, this.clientData[this.dataName]).then((data) => {
      this.afService.openSnackBar('Data successfully saved.');
    });
  }
}



// WEBPACK FOOTER //
// ./src/ng2/app/components/component-structure/component-structure.component.ts